import axios from 'axios';
import React, { useEffect, useState } from 'react';
import '../styling/result.css';
import { WhatsappShareButton, WhatsappIcon, FacebookShareButton, FacebookIcon, TelegramShareButton, TelegramIcon } from 'react-share';
import { Navigate, useNavigate } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export default function Result() {
    const navigate = useNavigate();
    const [score, setscore] = useState([]);
    const [copy, setcopy] = useState(`https://guessyourfriend.netlify.app/quiz/${localStorage.getItem('login_user_id')}/${localStorage.getItem('login_user_name')}`);
    useEffect(() => {
        const pro = new Promise((resolve, reject) => {
            const value = localStorage.getItem('login_user_id').toString();
            resolve(value);
        });
        pro.then(val => {
            axios.get(`https://quiz-backend-mqz8.onrender.com/ownscore/${val}`).then(
                res => setscore(res.data)
            );
        });
    }, []);
    const localdelete = () => {
        localStorage.removeItem('login_user_id');
        localStorage.removeItem('login_user_name');
        localStorage.removeItem('answer_completed');
        navigate('/');
    }
    return (
        <>
            {localStorage.getItem('login_user_id') ? <div className='result'>
                <div className="resultbox">
                    <div className="reshead">
                        <h3 className='resulthead'>Your quiz link is ready</h3>
                    </div>
                    {score.length > 0 ?
                        <div className="resulttable">
                            <div className="resultshead">Results:</div>
                            <div className="table">
                                <table className='restable'>
                                    <thead>
                                        <tr className='restr'>
                                            <td className="resdata">Name</td>
                                            <td className="resdata">Score</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {score.length > 0 ?
                                            score.map((indscore, index) => {
                                                return (
                                                    <tr className="restr" key={index}>
                                                        <td className="resnametd">
                                                            <div className="resname">{indscore.name}</div>
                                                        </td>
                                                        <td className="resscoretd">
                                                            <div className="resscore">{indscore.score}</div>
                                                        </td>

                                                    </tr>
                                                )
                                            }) : <div>loading...</div>}
                                    </tbody>
                                </table>
                            </div>
                        </div> : <div className="noscore">No one attemped your quiz yet</div>}
                    <div className="resultinstruction">
                        <ol>
                            <li className='listtemp'>Copy your quiz link</li>
                            <li className='listtemp'>Send it via email or share it using the social networks below</li>
                            <li className='listtemp'>Encourage your friends to take up the challenge</li>
                            <li className='listtemp'>Use the same link to come back later and see your friend's result</li>
                            <li className='listtemp'>Reload the page to see new results</li>
                        </ol>
                    </div>
                    <div className="linkbox">
                        <div className='textlinkhead'>Your quiz link :</div>
                        <input className='sendlinktext' type="text" value={copy} onChange={() => setcopy(prev => prev)} />
                        <CopyToClipboard text={copy} onCopy={() => alert('you can share your link now')}>
                            <button className="copy" >Copy link</button>
                        </CopyToClipboard>
                    </div>
                    <div className="sharequiz">
                        <h3 className="sharelinkshead">Share your link with:</h3>
                        <WhatsappShareButton title='Frindship quiz website makes your bond strong' className='sharebtn' url={`https://guessyourbond.netlify.app/quiz/${localStorage.getItem('login_user_id')}/${localStorage.getItem('login_user_name')}`}>
                            <WhatsappIcon size={40} round={true} />
                        </WhatsappShareButton>
                        <FacebookShareButton className='sharebtn' quote='Make your friendship bond strong with fun. 100% fun quiz website' url={`https://guessyourbond.netlify.app/quiz/${localStorage.getItem('login_user_id')}/${localStorage.getItem('login_user_name')}`}>
                            <FacebookIcon size={40} round={true} />
                        </FacebookShareButton>
                        <TelegramShareButton title='Frindship quiz website makes your bond strong' className='sharebtn' url={`https://guessyourbond.netlify.app/quiz/${localStorage.getItem('login_user_id')}/${localStorage.getItem('login_user_name')}`}>
                            <TelegramIcon size={40} round={true} />
                        </TelegramShareButton>
                    </div>
                    <div className='youcant'>(you can't see your old quiz)</div>
                    <div className="newquiz">
                        <button className="reenter" onClick={localdelete}>Create new quiz</button>
                    </div>
                </div>
            </div> : <Navigate to='/' />}
        </>
    )
}
